import { format, isValid } from 'date-fns';
import { useCallback } from 'react';
import { useConfig } from '@nexelem/config';

export type FormatDateFunction = (date: string | Date | undefined) => string | undefined;

type DateFormatterArgs = {
  displayWithHours?: boolean;
  onlyHours?: boolean;
};
export const useDateFormatter = ({ displayWithHours = false, onlyHours = false }: DateFormatterArgs) => {
  const {
    dateFormats: { withoutHours, withHours },
  } = useConfig();

  return useCallback(
    (date: string | Date | undefined) => {
      if (!date) {
        return undefined;
      }

      const parsedDate = new Date(date);
      if (!isValid(parsedDate)) {
        return undefined;
      }

      if (onlyHours) {
        return format(parsedDate, 'HH:mm');
      }
      if (displayWithHours) {
        return format(parsedDate, withHours);
      } else {
        return format(parsedDate, withoutHours);
      }
    },
    [displayWithHours, onlyHours, withHours, withoutHours],
  );
};
